import {
  StorageCountSessionStatus,
  StorageCountSessionStatusLabels,
  StorageCountVerdict,
  StorageCountVerdictLabels
} from '@navio/nsdk';
import { entriesToOptions, getLabelMapFromEntries } from './choiceOptions';

// US English spelling for the generated Django labels
const SESSION_STATUS_LABELS = { ...StorageCountSessionStatusLabels, CANCELLED: 'Canceled' };

export const STORAGE_COUNT_SESSION_STATUS_OPTIONS = entriesToOptions(StorageCountSessionStatus, SESSION_STATUS_LABELS);
export const STORAGE_COUNT_SESSION_STATUS_LABEL_MAP = getLabelMapFromEntries(
  StorageCountSessionStatus,
  SESSION_STATUS_LABELS
);

export const STORAGE_COUNT_VERDICT_OPTIONS = entriesToOptions(StorageCountVerdict, StorageCountVerdictLabels);
export const STORAGE_COUNT_VERDICT_LABEL_MAP = getLabelMapFromEntries(StorageCountVerdict, StorageCountVerdictLabels);
